import React, { useState } from 'react';
import { showToast } from '../../../Infrastructure/Notifications/ToastrConfig';
import { archiveClientAsync, deleteClientAsync, pauseClientAsync, unpauseClientAsync, updateMaxLearnersAsync } from './../../../Services/AdminService';
import PrimaryButton from './../../../Shared/Components/PrimaryButton/PrimaryButton';
import { useHistory } from 'react-router-dom';
import Modal from '../../../Shared/Components/Modal/Modal';

const ClientActions = ({ client, getClient }) => {
    const [maxLearners, setMaxLearners] = useState(0);
    const history = useHistory();

    const pauseClient = async () => {

        let data = {
            clientId: client.id,
        }

        let response = await pauseClientAsync(data);
        if (response.success) {
            showToast(true, "Client paused")
            getClient();
        }
        else {
            showToast(false, response.errors[0].error)
        }
    }

    const unPauseClient = async () => {
        let data = {
            clientId: client.id,
        }

        let response = await unpauseClientAsync(data);
        if (response) {
            showToast(true, "Client unpaused");
            getClient();
        }
        else {
            showToast(false, "Something went wrong")
        }
    }

    const deleteClient = async () => {
        let data = {
            clientId: client.id,
        }

        let response = await deleteClientAsync(data);
        if (response.success) {
            showToast(true, "Client deleted");
            history.push('/clients');
        }
        else {
            showToast(false, response.errors[0].error)
        }
    }

    const archiveClient = async () => {
        let data = {
            clientId: client.id,
        }

        let response = await archiveClientAsync(data);
        if (response.success) {
            showToast(true, "Client archived");
            history.push('/clients');
        }
        else {
            showToast(false, response.errors[0].error)
        }
    }

    const updateMaxLearners = async () => {

        let data = {
            clientId: client.id,
            maxLearners: maxLearners
        }

        let response = await updateMaxLearnersAsync(data);
        if (response.success) {
            showToast(true, "Maximum number of learners updated");
            getClient();
        }
        else {
            showToast(false, response.errors[0].error);
        }
    }

    const handleMaxLearnersChange = evt => {
        setMaxLearners(evt.target.value);
    }

    return (
        <>
            {/* Confirmation Modals */}
            <Modal
                modalId="pauseClientModal"
                bodyText={`Are you sure you want to pause ${client.name}? This will prevent learners from accessing their content.`}
                buttonFunc={pauseClient}
                buttonText="Pause Client"
                title="Pause Client"
            />
            <Modal
                modalId="unpauseClientModal"
                bodyText={`Are you sure you want to unpause ${client.name}? Learners will regain access to their content.`}
                buttonFunc={unPauseClient}
                buttonText="Unpause Client"
                title="Unpause Client"
            />
            <Modal
                modalId="deleteClientModal"
                bodyText={`Are you sure you want to DELETE ${client.name}? This action cannot be undone and will permanently remove all client data.`}
                buttonFunc={deleteClient}
                buttonText="Delete Client"
                title="Delete Client"
            />
            <Modal
                modalId="archiveClientModal"
                bodyText={`Are you sure you want to archive ${client.name}? Archived clients can be restored later.`}
                buttonFunc={archiveClient}
                buttonText="Archive Client"
                title="Archive Client"
            />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                {/* Update Max Learners Section */}
                <div style={{
                    background: 'linear-gradient(135deg, #f6f8fb 0%, #ffffff 100%)',
                    borderRadius: '12px',
                    padding: '20px',
                    border: '2px solid #e5e7eb'
                }}>
                    <label style={{
                        display: 'block',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        color: '#64748b',
                        marginBottom: '12px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                    }}>
                        Maximum Number of Learners
                    </label>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <input
                            onChange={handleMaxLearnersChange}
                            className="form-control"
                            type="number"
                            defaultValue={client.maximumNumberOfLearners}
                            min={client.numberOfLearners}
                            style={{
                                flex: '1',
                                padding: '12px 16px',
                                fontSize: '1rem',
                                border: '2px solid #e5e7eb',
                                borderRadius: '8px',
                                transition: 'all 0.2s',
                                maxWidth: '200px'
                            }}
                        />
                        <PrimaryButton text="Update" func={updateMaxLearners} classes="action-btn" />
                    </div>
                </div>

                {/* Client Management Actions */}
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    flexWrap: 'wrap'
                }}>
                    {client.isPaused ? (
                        <button
                            data-target="#unpauseClientModal"
                            data-toggle="modal"
                            style={{
                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '14px 28px',
                                fontSize: '0.95rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                boxShadow: '0 4px 12px rgba(16, 185, 129, 0.25)',
                                transition: 'all 0.3s',
                                flex: '1',
                                minWidth: '150px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.35)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.25)';
                            }}
                        >
                            ▶️ Unpause Client
                        </button>
                    ) : (
                        <button
                            data-target="#pauseClientModal"
                            data-toggle="modal"
                            style={{
                                background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '14px 28px',
                                fontSize: '0.95rem',
                                fontWeight: '600',
                                cursor: 'pointer',
                                boxShadow: '0 4px 12px rgba(245, 158, 11, 0.25)',
                                transition: 'all 0.3s',
                                flex: '1',
                                minWidth: '150px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(245, 158, 11, 0.35)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.25)';
                            }}
                        >
                            ⏸️ Pause Client
                        </button>
                    )}

                    <button
                        data-target="#deleteClientModal"
                        data-toggle="modal"
                        style={{
                            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '14px 28px',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(239, 68, 68, 0.25)',
                            transition: 'all 0.3s',
                            flex: '1',
                            minWidth: '150px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(239, 68, 68, 0.35)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.25)';
                        }}
                    >
                        🗑️ Delete Client
                    </button>

                    <button
                        data-target="#archiveClientModal"
                        data-toggle="modal"
                        style={{
                            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '14px 28px',
                            fontSize: '0.95rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(139, 92, 246, 0.25)',
                            transition: 'all 0.3s',
                            flex: '1',
                            minWidth: '150px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(139, 92, 246, 0.35)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.25)';
                        }}
                    >
                        📦 Archive Client
                    </button>
                </div>
            </div>
        </>
    );
};

export default ClientActions;